import React, { useEffect, useState, useRef } from 'react'
import HeroSection from '../../molecules/Gallery/HeroSection'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'
import Footer from '../../organisms/Footer/Footer'
import colors from '../../theme/color'
import commonfooter from '../../../assets/images/commonfooter.webp'
import CommanFooterCard from '../../atoms/CommanFooterCard/CommanFooterCard'
import galleryImage1 from '../../../assets/images/gallery/galleryimage1.webp'
import galleryImage2 from '../../../assets/images/gallery/galleryimage2.webp'
import galleryImage3 from '../../../assets/images/gallery/galleryimage3.webp'
import galleryImage4 from '../../../assets/images/gallery/galleryimage4.webp'
import galleryImage5 from '../../../assets/images/gallery/galleryimage5.webp'
import galleryImage6 from '../../../assets/images/gallery/galleryimage6.webp'
import galleryImage7 from '../../../assets/images/gallery/galleryimage7.webp'
import galleryImage8 from '../../../assets/images/gallery/galleryimage8.webp'
import galleryImage9 from '../../../assets/images/gallery/galleryimage9.webp'
import galleryImage10 from '../../../assets/images/gallery/galleryimage10.webp'
import galleryImage11 from '../../../assets/images/gallery/galleryimage11.webp'
import galleryImage12 from '../../../assets/images/gallery/galleryimage12.webp'
import galleryImage13 from '../../../assets/images/gallery/galleryimage13.webp'
import galleryImage14 from '../../../assets/images/gallery/galleryimage14.webp'
import galleryImage15 from '../../../assets/images/gallery/galleryimage15.webp'
import galleryImage16 from '../../../assets/images/gallery/galleryimage16.webp'
import galleryImage17 from '../../../assets/images/gallery/galleryimage17.webp'
import galleryImage18 from '../../../assets/images/gallery/galleryimage18.webp'
import eyeIcon from '../../../assets/images/gallery/icons/eye.svg'
import closeIcon from '../../../assets/images/gallery/icons/close.svg'
import chevronLeftIcon from '../../../assets/images/gallery/icons/chevron-left.svg'
import chevronRightIcon from '../../../assets/images/gallery/icons/chevron-right.svg'

const galleryImages = [
  galleryImage1,
  galleryImage2,
  galleryImage3,
  galleryImage4,
  galleryImage5,
  galleryImage6,
  galleryImage7,
  galleryImage8,
  galleryImage9,
  galleryImage10,
  galleryImage11,
  galleryImage12,
  galleryImage13,
  galleryImage14,
  galleryImage15,
  galleryImage16,
  galleryImage17,
  galleryImage18,
]

const GalleryPage = () => {
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null)
  const gridRef = useRef<HTMLDivElement | null>(null)

  const handleNextImage = () => {
    setSelectedImageIndex((prev) => {
      if (prev === null) return prev
      return prev < galleryImages.length - 1 ? prev + 1 : 0
    })
  }

  const handlePrevImage = () => {
    setSelectedImageIndex((prev) => {
      if (prev === null) return prev
      return prev > 0 ? prev - 1 : galleryImages.length - 1
    })
  }

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (selectedImageIndex === null) return
      if (event.key === 'ArrowRight') {
        event.preventDefault()
        handleNextImage()
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault()
        handlePrevImage()
      } else if (event.key === 'Escape') {
        setSelectedImageIndex(null)
      }
    }

    window.addEventListener('keydown', handleKeyPress)
    return () => window.removeEventListener('keydown', handleKeyPress)
  }, [selectedImageIndex])

  useEffect(() => {
    const grid = gridRef.current
    if (!grid) return

    const items = Array.from(grid.querySelectorAll<HTMLElement>('.gallery-card'))
    const revealed = new Set<number>()

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          const el = entry.target as HTMLElement
          const top = el.offsetTop
          if (revealed.has(top)) return
          revealed.add(top)

          // group items by the same offsetTop (row) and animate left->right
          const rowItems = items.filter((i) => Math.abs(i.offsetTop - top) < 6)
          rowItems.sort((a, b) => a.offsetLeft - b.offsetLeft)

          rowItems.forEach((ri, idx) => {
            ri.style.transition = `opacity 450ms ease ${idx * 90}ms, transform 450ms cubic-bezier(.2,.85,.25,1) ${idx * 90}ms`
            ri.style.opacity = '1'
            ri.style.transform = 'translateY(0)'
            // stop observing this element
            observer.unobserve(ri)
          })
        })
      },
      { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    )

    items.forEach((item) => {
      // ensure initial hidden state to avoid FOUC
      item.style.opacity = '0'
      item.style.transform = 'translateY(24px)'
      item.style.willChange = 'opacity, transform'
      observer.observe(item)
    })

    return () => observer.disconnect()
  }, [])

  return (
    <>
      <div
        className="relative min-h-screen overflow-x-hidden overflow-y-hidden text-white min-[2560px]:overflow-y-visible"
        style={{
          backgroundColor: colors.deepNavy,
          backgroundImage: `linear-gradient(to bottom right, ${colors.pageDark}, ${colors.deepNavy}, ${colors.panelDark})`,
        }}
      >
        <div className="relative z-10">
          <HeroSection />

          <div className="w-full">
            <div
              className="mb-10 w-full border-t-[3px] md:mb-12 lg:mb-14 2xl:mb-16 min-[2560px]:mb-0"
              style={{ borderTopColor: colors.purpleAlt }}
            />
          </div>

          <div
            aria-hidden
            className="pointer-events-none absolute -right-20 top-[42%] z-0 h-60 w-60 rounded-full blur-3xl md:top-[38%] md:h-80 md:w-80 lg:top-[34%] lg:h-96 lg:w-96 xl:-right-24 xl:top-[30%] 2xl:-right-28 2xl:top-[28%] min-[2560px]:-right-36 min-[2560px]:top-[24%] min-[2560px]:h-[520px] min-[2560px]:w-[520px]"
            style={{ backgroundColor: `${colors.purpleAlt}33` }}
          />

          <section className="w-full px-10 pb-14 sm:px-12 md:px-14 lg:px-20 lg:pb-20 xl:px-24 2xl:px-28 min-[2560px]:mt-6 min-[2560px]:px-40">
            <div className="relative mx-auto w-full max-w-[1920px] min-[2560px]:max-w-[2100px]">
              <div ref={gridRef} className="relative z-10 grid grid-cols-[repeat(auto-fill,minmax(min(100%,15rem),1fr))] gap-5 sm:grid-cols-[repeat(auto-fill,minmax(min(100%,16.5rem),1fr))] sm:gap-6 md:grid-cols-[repeat(auto-fill,minmax(min(100%,17.5rem),1fr))] md:gap-7 lg:grid-cols-[repeat(auto-fill,minmax(min(100%,18rem),1fr))] lg:gap-8 xl:grid-cols-[repeat(auto-fill,minmax(min(100%,22rem),1fr))] 2xl:grid-cols-[repeat(auto-fill,minmax(min(100%,21rem),1fr))] min-[2560px]:grid-cols-[repeat(auto-fill,minmax(min(100%,27rem),1fr))]">
                {galleryImages.map((image, index) => (
                  <button
                    key={`${image}-${index}`}
                    type="button"
                    onClick={() => setSelectedImageIndex(index)}
                    className="gallery-card group relative w-full aspect-square overflow-hidden rounded-3xl border border-white/10 shadow-[0_6px_18px_rgba(0,0,0,0.22)] md:shadow-[0_10px_26px_rgba(0,0,0,0.24)] lg:shadow-[0_12px_30px_rgba(0,0,0,0.24)] 2xl:shadow-[0_14px_36px_rgba(0,0,0,0.26)] min-[2560px]:shadow-[0_16px_40px_rgba(0,0,0,0.28)] sm:rounded-4xl"
                    style={{ backgroundColor: colors.blogCardPanel, opacity: 0, transform: 'translateY(24px)' }}
                    aria-label={`Open gallery image ${index + 1}`}
                  >
                    <img
                      src={image}
                      alt={`Gallery item ${index + 1}`}
                      className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 flex items-center justify-center bg-black/55 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                      <span className="rounded-full p-3 text-white" style={{ backgroundColor: colors.purpleAlt }}>
                        <img src={eyeIcon} alt="" className="h-7 w-7" aria-hidden />
                      </span>
                    </div>
                    <div className="pointer-events-none absolute inset-0 rounded-3xl border-2 opacity-0 transition-opacity duration-300 group-hover:opacity-100 sm:rounded-4xl" style={{ borderColor: colors.purpleAlt }} />
                  </button>
                ))}
              </div>
            </div>
          </section>

          <section className="w-full overflow-visible px-4 pb-24 pt-10 sm:px-6 md:px-8 lg:px-6 lg:pt-14 xl:px-8 min-[2560px]:pb-[600px] min-[2560px]:pt-20">
            <div className="mx-auto w-full max-w-[1760px] min-[1440px]:max-w-[1920px] 2xl:max-w-[2160px] min-[2560px]:max-w-[2440px] min-[2560px]:origin-top min-[2560px]:scale-[1.5]">
            <CommanFooterCard
 paragraph="We believe in giving back. Our team contributes to open source projects and shares knowledge through blog posts, conference talks, and community events."
imageSrc={commonfooter}
imageAlt="About us leadership profile"
overlayGradient="linear-gradient(0deg, #874bff7d 17.11%, rgba(135, 75, 255, 0) 100%)"
/>
              <Testimonial className="mx-auto mb-20 max-w-[90%]"/>
            </div>
          </section>

          <section className="mb-10 w-full px-4 sm:px-6 md:px-8 lg:px-6 lg:mb-16 xl:px-8">
            <div className="mx-auto grid w-full max-w-[1760px] grid-cols-1 gap-5 min-[1440px]:max-w-[1920px] lg:min-h-[725px] lg:grid-cols-[1fr_2fr] 2xl:max-w-[2160px] min-[2560px]:max-w-[2440px]">
              <Message />
              <Questions />
            </div>
          </section>

          <Footer />
        </div>
      </div>

      {selectedImageIndex !== null && (
        <div
          className="fixed inset-0 z-50 flex flex-col items-center justify-center p-4"
          style={{ backgroundColor: colors.panelDark }}
          onClick={() => setSelectedImageIndex(null)}
        >
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation()
              setSelectedImageIndex(null)
            }}
            className="absolute right-4 top-4 z-20 rounded-full bg-black/60 p-2 text-white transition-all hover:bg-black/80"
            aria-label="Close preview"
          >
            <img src={closeIcon} alt="" className="h-6 w-6" aria-hidden />
          </button>

          {galleryImages.length > 1 && (
            <div className="mb-4 flex max-w-[90vw] gap-2 overflow-x-auto pb-2">
              {galleryImages.map((image, index) => (
                <button
                  key={`thumb-${image}-${index}`}
                  type="button"
                  className={`h-14 w-14 shrink-0 overflow-hidden rounded border-2 transition-all ${
                    selectedImageIndex === index ? 'opacity-100 scale-110' : 'opacity-60 hover:opacity-85'
                  }`}
                  style={{ borderColor: selectedImageIndex === index ? colors.purpleAlt : 'transparent' }}
                  onClick={(event) => {
                    event.stopPropagation()
                    setSelectedImageIndex(index)
                  }}
                  aria-label={`View image ${index + 1}`}
                >
                  <img src={image} alt={`Thumbnail ${index + 1}`} className="h-full w-full object-cover" />
                </button>
              ))}
            </div>
          )}

          <div className="relative flex w-full max-w-6xl items-center justify-center gap-4">
            {galleryImages.length > 1 && (
              <button
                type="button"
                onClick={(event) => {
                  event.stopPropagation()
                  handlePrevImage()
                }}
                className="z-10 rounded-full bg-black/60 p-3 text-white transition-all hover:bg-black/80"
                aria-label="Previous image"
              >
                <img src={chevronLeftIcon} alt="" className="h-8 w-8" aria-hidden />
              </button>
            )}

            <div className="flex-1" onClick={(event) => event.stopPropagation()}>
              <img
                src={galleryImages[selectedImageIndex]}
                alt={`Gallery preview ${selectedImageIndex + 1}`}
                className="mx-auto max-h-[72vh] w-auto max-w-full rounded-3xl object-contain"
              />
            </div>

            {galleryImages.length > 1 && (
              <button
                type="button"
                onClick={(event) => {
                  event.stopPropagation()
                  handleNextImage()
                }}
                className="z-10 rounded-full bg-black/60 p-3 text-white transition-all hover:bg-black/80"
                aria-label="Next image"
              >
                <img src={chevronRightIcon} alt="" className="h-8 w-8" aria-hidden />
              </button>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default GalleryPage
